import { render, staticRenderFns } from "./Calendar.vue?vue&type=template&id=ef451856&scoped=true&lang=html&"
import script from "./Calendar.vue?vue&type=script&lang=js&"
export * from "./Calendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef451856",
  null
  
)

export default component.exports